import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { formatRupiah } from "@/lib/constants";
import { Input } from "@/components/ui/input";
import { ShieldCheck, Search } from "lucide-react";

const fmt = (v) => (v === null || v === undefined || v === "" ? "-" : typeof v === "object" ? JSON.stringify(v).slice(0, 80) : String(v));

export default function FinAuditLog() {
  const [q, setQ] = useState("");
  const [rows, setRows] = useState([]);
  useEffect(() => { const t = setTimeout(() => api.get("/finance/audit-log", { params: { q } }).then((r) => setRows(r.data.rows || [])).catch(() => {}), 300); return () => clearTimeout(t); }, [q]);
  return (
    <div data-testid="fin-audit-page" className="mx-auto max-w-4xl">
      <h1 className="font-heading flex items-center gap-2 text-[22px] font-extrabold text-[#111827]"><ShieldCheck className="text-[#1E3A5F]" />Audit Log</h1>
      <p className="text-[13px] text-[#475569]">Catatan tidak dapat diubah · user, role, waktu, nilai sebelum/sesudah, alasan & status approval.</p>
      <div className="relative mt-3"><Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" /><Input data-testid="fin-audit-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cari jenis / user / referensi…" className="h-10 pl-9" /></div>
      <div className="mt-3 space-y-1.5">
        {rows.map((r, i) => (
          <div key={i} data-testid="fin-audit-row" className="rounded-lg border border-[#E2E5EA] bg-white px-3 py-2 text-[13px]">
            <div className="flex flex-wrap items-center justify-between gap-1"><b className="text-[#1E3A5F]">{r.type || r.event}</b><span className="text-[12px] text-[#475569]">{String(r.at || "").slice(0, 19).replace("T", " ")}</span></div>
            <div className="text-[#334155]">{r.by || r.user_email || "-"} · {r.user_id || "-"} · {r.role || "-"}{r.ref ? ` · Ref ${r.ref}` : ""}{r.estimate_no ? ` · ${r.estimate_no}` : ""}</div>
            {(r.before !== undefined || r.after !== undefined) && <div className="text-[12px] text-[#475569]">{fmt(r.before)} → <b>{fmt(r.after)}</b>{r.amount ? ` · ${formatRupiah(r.amount)}` : ""}{r.reason ? ` · alasan: ${r.reason}` : ""}{r.approval_status ? ` · ${r.approval_status}` : ""}</div>}
          </div>
        ))}
        {rows.length === 0 && <p className="py-8 text-center text-[14px] text-[#475569]">Belum ada catatan.</p>}
      </div>
    </div>
  );
}
